export enum LoadingStateEnum {
  idle = 'idle',
  loading = 'loading',
  loaded = 'loaded',
  error = 'error'
}
